
import { useState } from 'react';
import { UserFormValues } from '@/components/auth/UserInfoForm';
import { CardDetails } from '@/types/payment';
import { SignUpStep } from './types';

export interface FormData {
  user: UserFormValues;
  card: CardDetails;
  bitcoinAddress?: string;
  termsAccepted: boolean;
  userExists: boolean;
  verificationMethod: 'card' | 'bitcoin';
}

export const useSignUpFormState = () => {
  const [step, setStep] = useState<SignUpStep>('user');
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    user: {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
    },
    card: {
      cardNumber: '',
      cardholderName: '',
      expiryDate: '',
      cvv: '',
      saveCard: true,
    },
    termsAccepted: false,
    userExists: false,
    verificationMethod: 'card'
  });

  const updateUserData = (data: UserFormValues) => {
    setFormData(prev => ({
      ...prev,
      user: data
    }));
  };

  const updateCardData = (data: Partial<CardDetails>, termsAccepted?: boolean) => {
    setFormData(prev => ({
      ...prev,
      card: { ...prev.card, ...data },
      termsAccepted: termsAccepted !== undefined ? termsAccepted : prev.termsAccepted
    }));
  };

  const updateBitcoinData = (bitcoinAddress: string, termsAccepted?: boolean) => {
    setFormData(prev => ({
      ...prev,
      bitcoinAddress,
      termsAccepted: termsAccepted !== undefined ? termsAccepted : prev.termsAccepted
    }));
  };

  const updateVerificationMethod = (method: 'card' | 'bitcoin') => {
    setFormData(prev => ({
      ...prev,
      verificationMethod: method
    }));
  };

  const updateUserExists = (exists: boolean) => {
    setFormData(prev => ({
      ...prev,
      userExists: exists
    }));

    // If user exists, go to signin; otherwise go to either card or bitcoin
    // based on current verification method
    setStep(exists ? 'signin' : formData.verificationMethod);
  };

  return {
    step,
    setStep,
    formData,
    isSigningIn,
    setIsSigningIn,
    updateUserData,
    updateCardData,
    updateBitcoinData,
    updateVerificationMethod,
    updateUserExists
  };
};
